import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calculator, Target, TrendingUp, ArrowRight } from "lucide-react";
import { CALC } from "@/constants/testIds";

const items = [
  { id: "sip", to: "/calculators#sip", icon: Calculator, t: "SIP Calculator", d: "How much will my monthly SIP grow into?" },
  { id: "lumpsum", to: "/calculators#lumpsum", icon: TrendingUp, t: "Lumpsum Calculator", d: "Project a one-time investment's future value." },
  { id: "goal", to: "/calculators#goal", icon: Target, t: "Goal Planner", d: "Reverse-calculate the SIP for any goal." },
  { id: "stepup", to: "/calculators#stepup", icon: TrendingUp, t: "Step-up SIP", d: "Grow your SIP with your salary." },
];

export default function CalculatorsTeaser() {
  return (
    <section data-testid={CALC.hub} className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
      <div className="grid md:grid-cols-12 gap-10 mb-14">
        <div className="md:col-span-6">
          <span className="text-xs uppercase tracking-[0.25em] text-secondary font-medium">Play with numbers</span>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-primary mt-3 leading-[1.1]">
            Calculators that <em className="not-italic text-secondary">explain themselves.</em>
          </h2>
        </div>
        <div className="md:col-span-6 md:pt-4">
          <p className="text-lg text-foreground/75 leading-relaxed">
            No spreadsheets. No accountants needed. Move a slider, watch the chart, understand the
            magic of compounding in 30 seconds.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((it, i) => (
          <motion.div
            key={it.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
          >
            <Link
              to={it.to}
              className="block bg-card rounded-2xl border border-border p-6 h-full hover:-translate-y-1 hover:shadow-md transition-all"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary grid place-items-center mb-4">
                <it.icon className="w-5 h-5" />
              </div>
              <h3 className="font-serif text-xl text-primary">{it.t}</h3>
              <p className="text-sm text-foreground/65 mt-2 leading-relaxed">{it.d}</p>
              <span className="inline-flex items-center gap-1 text-sm text-secondary font-medium mt-4">
                Open <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
